<template>
  <div class="fdc mt-20">
    <div  v-if="true==cshow">
        <p v-if="index == true" class="operate" @click.prevent="onClick()">
          <img  src="@/assets/images/nostars.png" alt="">          
          <span style="margin-left:5px;">收藏</span>
        </p>
        <p v-else class="operate" @click.prevent="onCall()">
          <!-- <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconshoucang"></use>
          </svg> -->
          <!-- <img v-if="active" :src="require('@/assets/images/stars.png')" > -->
          <img  src="@/assets/images/stars.png" alt="">          
          <span style="margin-left:5px;">收藏</span>
        </p>

    </div>  
    <div class="operate f1 ml-50">
      <span>分享：</span>
      <div class="shareIcon">
        <svg @click="qrShowSwitch" class="icon" aria-hidden="true">
          <use xlink:href="#iconweixin"></use>
        </svg>
        <div v-clickoutside="qrHide" v-show="qrShow" class="qrContainer">
          <canvas id="canvas"></canvas>
          微信分享
        </div>
      </div>

      <svg @click="shareWb" class="icon" aria-hidden="true">
        <use xlink:href="#iconweibo"></use>
      </svg>
      <svg @click="qqShare" class="icon" aria-hidden="true">
        <use xlink:href="#iconQQ"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import '@/assets/js/iconfont.js';
import Clickoutside from "element-ui/src/utils/clickoutside";
import {getToken} from '@/utils/auth'
import QRCode from "qrcode";
export default {
  props:{
    shareObj:{
      type: Object,
    },
	  notStatus:{
     type:Boolean
    },
    hidecollection:{
      type:Boolean,
    }
    
  },
  directives: { Clickoutside },
  data() {
    return {
      qrShow: false,
      cshow:true,
      active:0,
      index:true
    };
  },
  created(){
    this.notStatus == true ? this.index = false : this.index = true;
    if(this.hidecollection != null && this.hidecollection == true){
      this.cshow = false;
    }
   
  },
  mounted() {
  
    this.qrCode(location.href);    
  },  
  methods: {
    qrHide() {
      this.qrShow = false;
    },
    //QQ分享
    qqShare() {
      var _shareUrl =
        "http://connect.qq.com/widget/shareqq/index.html?";
      _shareUrl += "url=" + encodeURIComponent(location.href); //分享的链接
      _shareUrl += "&title=" + encodeURIComponent(this.shareObj.title || this.shareObj.name); //分享的标题
      window.open(_shareUrl, "qq", "height=430, width=400");
    },
    //微博分享
    shareWb() {
      this.shareWeiBo({
        title: this.shareObj.title || this.shareObj.name,
        url: location.href,
        pic: this.shareObj.cover,
      });
    },
    shareWeiBo({ title, url, pic }) {
      var param = {
        url: url || window.location.href,
        type: "3",
        count: "1" /** 是否显示分享数，1显示(可选)*/,
        appkey: "" /** 您申请的应用appkey,显示分享来源(可选)*/,
        title: title /** 分享的文字内容(可选，默认为所在页面的title)*/,
        pic: pic || "" /**分享图片的路径(可选)*/,
        ralateUid: "" /**关联用户的UID，分享微博会@该用户(可选)*/,
        rnd: new Date().valueOf(),
      };
      var temp = [];
      for (var p in param) {
        temp.push(p + "=" + encodeURIComponent(param[p] || ""));
      }
      var targetUrl =
        "http://service.weibo.com/share/share.php?" + temp.join("&");
      window.open(targetUrl, "sinaweibo", "height=430, width=400");
    },
    //收藏
    onClick() { 
      if(getToken() != undefined){
         this.$emit("onCollection");
         this.index = !this.index;
         this.notStatus=true;
      }else{
         this.$router.replace('/login');
      }
    },
    //取消收藏
    onCall(){
      this.index = !this.index;
      this.$emit("callCollection"); 
    },

    qrShowSwitch() {
      this.qrShow = !this.qrShow;
    },
    qrCode(link) {
      const canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, link, function (error) {
        if (error) console.error(error);
      });
    }
  },
};
</script>

<style scoped>
.icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.stars {
  width: 19px;
  height: 18px;
  vertical-align: middle;
}
.banns {
  width: 100%;
  height: 400px;
}
.operate {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.operate .icon {
  margin-right: 20px;
  cursor: pointer;
}
.operate img {
  width: 20px;
  height: 19px;
  vertical-align: middle;
  cursor: pointer;
}
.shareIcon {
  position: relative;
  display: flex;
}
.shareIcon .qrContainer {
  display: flex;
  flex-direction: column;
  position: absolute;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  background: #fff;
  padding-bottom: 10px;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
}
.f1 {
  flex: 1;
}
.fsb {
  display: flex;
  justify-content: space-between;
}
.colors {
  color: #ff7302;
  font-size: 14px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
  width: 300px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-50 {
  margin-left: 50px;
}
.mb-60 {
  margin-bottom: 60px;
}
.pl-10 {
  padding-left: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.top_img {
  width: 100%;
  height: 293px;
}
.college_middle {
  padding: 10px 15px;
}
.college_middle h4 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;
}
.college_middle p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.college_bater {
  height: 41px;
  line-height: 41px;
  background: #eeeeee;
}
.college_btn {
  width: 114px;
  height: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  font-size: 12px;

  border-radius: 3px;
}
.background1 {
  background: #f6bc20;
}
.background2 {
  background: #ff7302;
}

.college_meter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
}
.college_photo {
  width: 100%;
  height: 346px;
}
.college_shire {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.shire_btn {
  margin-top: 50px;
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.college_recom {
  width: 32%;
}
.college_recom img {
  width: 100%;
  height: 162px;
}
.college_recom p {
  padding-top: 10px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.button-prev,
.button-next {
  width: 100%;
  line-height: 20px;
  text-align: center;
  background: linear-gradient(-79deg, #ff7602, #ffc602);
}
.swiper-container {
  height: 360px;
  border-right: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  padding: 0 10px;
}
.swiper-wrapper {
  height: 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.swiper-slide {
  height: 120px;
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.swiper-slide img {
  margin-left: 10px;
  width: 89px;
  height: 89px;
}
.export_desc {
  margin: 0px 10px;
}
.export_desc p:nth-child(1) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
}
.export_desc p:nth-child(2) {
  margin-top: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  /*多行溢出省略*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/common/userOperation.vue